import styled from "styled-components";
import { fieldStyles } from "./ui";

const Dropdown = ({ placeholder, name, setPayload, options, errorMessage, errorType }) => {
  return (
    <Select
      id = { name }
      aria-label = { placeholder }
      name = { name }
      onChange= { e => { handleChange(e, setPayload) } }
      data-error-message = { errorMessage }
      data-error-type = { errorType }
    >
      <option value=''>Select</option>
      {getOptions(options)}
    </Select>
  );
};

const getOptions = (options) => {
  if(options) {
    return Object.keys(options).map((key) =>
      <option value={ key } key= { key }>{ options[key] }</option>
    );
  } else {
    return null;
  }
}

const handleChange = (e, setPayload) => {
  setPayload(e.target.name, e.target.value);
}

const Select = styled.select`
  ${fieldStyles}
  margin-bottom: 16px;
  appearance: none;
  -webkit-appearance: none;
  padding-right: 42px;
  cursor: pointer;
  background-image:
    linear-gradient(45deg, transparent 50%, var(--text-muted) 50%),
    linear-gradient(135deg, var(--text-muted) 50%, transparent 50%);
  background-position:
    calc(100% - 22px) 50%,
    calc(100% - 16px) 50%;
  background-size: 6px 6px;
  background-repeat: no-repeat;
`;

export default Dropdown;
